import api from '../api';

class PropertiesEmailsService {
  async getEmailGuardiansData(propertyId) {
    try {
      const response = await api.get(`/properties/${propertyId}/emails/guardians/create`);
      return response.data;
    } catch (error) {
      console.error('Error fetching email guardians data:', error);
      // Return mock data as fallback
      return this.getMockEmailGuardiansData(propertyId);
    }
  }

  async sendEmailToGuardians(propertyId, formData) {
    try {
      const response = await api.post(`/properties/${propertyId}/emails/guardians/store`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error sending email to guardians:', error);
      throw error;
    }
  }

  getMockEmailGuardiansData(propertyId) {
    return {
      success: true,
      data: {
        property: {
          id: propertyId,
          property_id: `PROP-${propertyId}`,
          name: "Test Property",
          address_1: "123 Test Street",
          address_2: "Apartment 4B",
          address_3: "Building A",
          town: "London",
          postcode: "TE1 1ST",
          status: "Active",
          statusText: "Active",
          date_live: "2023-01-15",
          date_taken_on: "2023-01-15",
          date_taken_back: null,
          date_notice: null,
          shouldDisplayDate: (date) => {
            if (!date) return '';
            return new Date(date).toLocaleDateString('en-GB');
          }
        },
        guardians: [
          {
            id: 1,
            fullName: "John Smith",
            unique_guardian_number: "UGD001",
            status: { name: "Active" },
            latest_rent: {
              room: {
                name: "Room 1A"
              }
            }
          },
          {
            id: 2,
            fullName: "Jane Doe",
            unique_guardian_number: "UGD002",
            status: { name: "Active" },
            latest_rent: {
              room: {
                name: "Room 2B"
              }
            }
          },
          {
            id: 3,
            fullName: "Mike Johnson",
            unique_guardian_number: "UGD003",
            status: { name: "Active" },
            latest_rent: {
              room: {
                name: "Room 3C"
              }
            }
          },
          {
            id: 4,
            fullName: "Sarah Wilson",
            unique_guardian_number: "UGD004",
            status: { name: "Active" },
            latest_rent: {
              room: {
                name: "Room 4D"
              }
            }
          },
          {
            id: 5,
            fullName: "David Brown",
            unique_guardian_number: "UGD005",
            status: { name: "Active" },
            latest_rent: {
              room: {
                name: "Room 5E"
              }
            }
          }
        ]
      }
    };
  }
}

export default new PropertiesEmailsService(); 